import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Typography,
  Grid,
} from '@mui/material';
import ReminderScheduleConfig from './ReminderScheduleConfig';

const ReminderCampaignConfig = ({
  campaign,
  onCampaignChange,
  templates,
  communicationEndpoints,
  timezones,
}) => {
  const handleChannelChange = (event) => {
    onCampaignChange({
      ...campaign,
      channel: event.target.value,
    });
  };

  const handleScheduleChange = (updatedSchedule) => {
    onCampaignChange({
      ...campaign,
      reminder_schedule: updatedSchedule,
    });
  };

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel>Channel</InputLabel>
            <Select
              value={campaign.channel}
              onChange={handleChannelChange}
              label="Channel"
            >
              <MenuItem value="email">Email</MenuItem>
              <MenuItem value="sms">SMS</MenuItem>
              <MenuItem value="voice">Voice</MenuItem>
              <MenuItem value="chat">Chat</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <ReminderScheduleConfig
            schedule={campaign.reminder_schedule}
            onScheduleChange={handleScheduleChange}
            timezones={timezones}
            templates={templates}
            communicationEndpoints={communicationEndpoints}
            channel={campaign.channel}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

ReminderCampaignConfig.propTypes = {
  campaign: PropTypes.shape({
    channel: PropTypes.oneOf(['email', 'sms', 'voice', 'chat']).isRequired,
    reminder_schedule: PropTypes.shape({
      use_relative_schedule: PropTypes.bool.isRequired,
      business_hours_only: PropTypes.bool.isRequired,
      timezone: PropTypes.string.isRequired,
      reminder_times: PropTypes.arrayOf(
        PropTypes.shape({
          days_before: PropTypes.number,
          time: PropTypes.string,
          days_before_relative: PropTypes.number,
          hours_before: PropTypes.number,
          minutes_before: PropTypes.number,
          messages: PropTypes.arrayOf(
            PropTypes.shape({
              template: PropTypes.string,
              email_config: PropTypes.object,
              sms_config: PropTypes.object,
              voice_config: PropTypes.object,
              chat_config: PropTypes.object,
            })
          ),
        })
      ).isRequired,
    }).isRequired,
  }).isRequired,
  onCampaignChange: PropTypes.func.isRequired,
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  communicationEndpoints: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ).isRequired,
  timezones: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ReminderCampaignConfig; 